import { Controller } from "@hotwired/stimulus";

// Snaps calendar clicks to 15-minute increments. Keeps prefill consistent regardless of appointment type booking interval.
const SNAP_INTERVAL_MINUTES = 15;

export default class extends Controller {
  static values = {
    hourHeight: Number,
    appointmentTypeId: Number,
    drawerUrl: String,
    drawerFrameId: String,
  };

  clickColumn(event) {
    if (!this.appointmentTypeIdValue) return;

    // Only handle clicks inside the scrollable grid (day columns), not headers or buttons
    const column = event.target.closest("[data-date]");
    if (!column) return;

    // Don't intercept clicks on appointment cards (detail drawer) or links
    if (
      event.target.closest("[data-calendar-appointment-ignore]") ||
      event.target.closest("a") ||
      event.target.closest("button")
    ) {
      return;
    }

    const date = column.dataset.date;
    if (!date) return;

    const rect = column.getBoundingClientRect();
    const y = event.clientY - rect.top;
    const totalMinutes = (y / this.hourHeightValue) * 60;

    const minutes = this.snapToQuarterHour(totalMinutes);

    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const time = `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;

    // Determine if clicked time is within an availability window
    const availBlocks = column.querySelectorAll("[data-avail-start]");
    let insideAvailability = false;
    availBlocks.forEach((block) => {
      const start = parseInt(block.dataset.availStart, 10);
      const end = parseInt(block.dataset.availEnd, 10);
      if (minutes >= start && minutes < end) {
        insideAvailability = true;
      }
    });

    const outsideParam = insideAvailability ? "" : "&outside_availability=1";
    const url = `${this.drawerUrlValue}?appointment_type_id=${this.appointmentTypeIdValue}&date=${date}&time=${time}${outsideParam}`;
    const frameId = this.drawerFrameIdValue || "appointment_create_drawer";

    event.preventDefault();
    event.stopPropagation();

    // Load form into drawer frame via Turbo, then open drawer
    const frame = document.getElementById(frameId);
    if (frame) {
      frame.src = url;
    }
    document.dispatchEvent(new CustomEvent("drawer:open", { detail: { frameId } }));
  }

  /**
   * Snap minutes-since-midnight to nearest 15-minute increment.
   * Uses Math.round so 9:07 → 9:00, 9:08 → 9:15, 9:22 → 9:30, 9:38 → 9:45.
   * Clamps to [0, 24*60 - SNAP_INTERVAL] so the last slot ends before midnight.
   */
  snapToQuarterHour(minutes) {
    const snapped = Math.round(minutes / SNAP_INTERVAL_MINUTES) * SNAP_INTERVAL_MINUTES;
    return Math.max(0, Math.min(1440 - SNAP_INTERVAL_MINUTES, snapped));
  }
}
